module.exports = __webpack_public_path__ + "img/dialog-bg.4a68a7e4.png";